import coreApiClient from "@/providers/core-api/CoreApi"

export default {
  getToken(payload) {
    return coreApiClient.sendRequest("post", "/v1/auth/token", payload)
  },
  authorisePusher(socketId, channel) {
    let payload = {
      socket_id: socketId,
      channel_name: channel.name
    }

    return coreApiClient.sendRequest("post", "/v1/auth/pusher", payload)
  }
}
